import React from 'react';
import { Link } from 'react-router-dom';

import bgImg from '../../assets/img/cta/cta-bg.png';
import ctaIcon from '../../assets/img/cta/cta-icon.png';

const CTA = (props) => {
  const { ctaBG, ctaClass, Title, Description, btnText, btnURL } = props;

  return (
    <div
      className={
        ctaClass
          ? ctaClass
          : 'cta__area cta__bg cta__bg-2 cta__plr p-relative wow animate__fadeInUp'
      }
      data-wow-duration=".9s"
      data-wow-delay=".5s"
      style={{ backgroundImage: `url(${ctaBG ? ctaBG : bgImg})` }}
    >
      <div className="cta__shape-icon d-none d-md-block">
        <img src={ctaIcon} alt="" />
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="cta__section-wrapper text-center">
              <div className="cta__section-box">
                <h4
                  className="cta__title text-white wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".7s"
                >
                  {Title ? Title : 'Let’s Build the Future of Business Together'}
                </h4>
                <p
                  className="text-white  wow animate__fadeInUp"
                  data-wow-duration=".9s"
                  data-wow-delay=".9s"
                >
                  {Description
                    ? Description
                    : "Whether you're looking to innovate, optimize, or scale, TGVC Technologies is your strategic partner for reliable and intelligent tech solutions — across industries and across the globe."}
                </p>
              </div>
              <div
                className="cta__btn wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay="1.1s"
              >
                <Link
                  to={`/${btnURL ? btnURL : 'contact'}`}
                  className="white-btn tp-btn-hover alt-color"
                >
                  <span>{btnText ? btnText : 'Get Started'}</span>
                  <b></b>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTA;
